var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0026 64.1663C18.8939 64.1663 5.83594 51.1084 5.83594 34.9997C5.83594 18.8909 18.8939 5.83301 35.0026 5.83301C51.1114 5.83301 64.1693 18.8909 64.1693 34.9997C64.1693 51.1084 51.1114 64.1663 35.0026 64.1663ZM35.0026 58.333C41.191 58.333 47.1259 55.8747 51.5018 51.4988C55.8776 47.123 58.3359 41.1881 58.3359 34.9997C58.3359 28.8113 55.8776 22.8764 51.5018 18.5005C47.1259 14.1247 41.191 11.6663 35.0026 11.6663C28.8142 11.6663 22.8793 14.1247 18.5034 18.5005C14.1276 22.8764 11.6693 28.8113 11.6693 34.9997C11.6693 41.1881 14.1276 47.123 18.5034 51.4988C22.8793 55.8747 28.8142 58.333 35.0026 58.333ZM32.0947 46.6663L19.7193 34.2909L23.8434 30.1668L32.0947 38.418L48.5914 21.9184L52.7184 26.0426L32.0947 46.6663Z",
    fill: "#07C257"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccesIcon);
export default __webpack_public_path__ + "static/media/succesIcon.5051b137a4a59e49a28cc0de9637f07d.svg";
export { ForwardRef as ReactComponent };